"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _selectMultiCode = _interopRequireDefault(require("./select-multi-code"));
var _selectOptions = require("./select-options");
var _modal = _interopRequireDefault(require("./modal"));
var _button = _interopRequireDefault(require("./button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class EditableMultiSelect extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      choosing: false
    });
    _defineProperty(this, "_getOptions", () => {
      if (!this.props.loaded) return [];
      return (0, _selectOptions.selectOptions)(this.props);
    });
    _defineProperty(this, "_getCodeString", () => {
      if (!this.props.loaded) return '';
      return this.props.selectedCodes.map(selectedCode => {
        const option = this._getOptions().filter(opt => opt.value === selectedCode);
        if (!option.length) return selectedCode;
        return option[0].label;
      }).join('; ');
    });
    _defineProperty(this, "_onEdit", () => {
      if (!this.state.choosing) {
        this.setState({
          choosing: true
        });
      }
    });
    _defineProperty(this, "_onFinish", () => {
      if (this.state.choosing) {
        this.setState({
          choosing: false
        });
      }
    });
  }
  render() {
    if (!this.props.enabled) return /*#__PURE__*/_react.default.createElement("span", {
      className: "read-only"
    }, this._getCodeString());
    if (this.state.choosing) return /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onFinish
      }, "Done"),
      onClose: this._onFinish,
      title: this.props.title || 'Select Options'
    }, /*#__PURE__*/_react.default.createElement(_selectMultiCode.default, {
      lookup: this.props.lookup,
      codeType: this.props.codeType,
      name: this.props.name,
      colSize: this.props.colSize,
      selectedCodes: this.props.selectedCodes,
      onChange: this.props.onChange
    }));
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-block btn-editable",
      onClick: this._onEdit,
      type: "button",
      style: {
        minHeight: 23
      }
    }, this._getCodeString());
  }
}

// *************************************************************
// Data
// *************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(EditableMultiSelect, props => (0, _selectOptions.selectQuery)(props), undefined, {
  renderLoading: true
});